import { COMMON_API, HTTP_REQUEST_TYPE } from "../constants/api";
import { getAccessToken } from "../config/authConfig";
import { sendHttpRequest } from "./api";


const getAircraftTypeList = async () => {
  const [, resp] = await sendHttpRequest(
    HTTP_REQUEST_TYPE.get,
    COMMON_API.GET_AIRCRAFT_TYPE,
    {}
  );
  return resp;
};

interface UploadFilesParams {
  files: File[];
  path: string;
  type: string;
}

interface UploadResponse {
  code: number;
  msg?: string;
  data?: {
    fileIds: Array<{
      fileId: string;
      name: string;
    }>;
  };
  message?: string;
}

const uploadFiles = async (params: UploadFilesParams): Promise<UploadResponse> => {
  const formData = new FormData();
  
  console.log('=== Upload Files Debug ===');
  console.log('Input files:', params.files);
  console.log('Files count:', params.files.length);
  
  // Append all files
  for (const file of params.files) {
    console.log('Appending file:', file.name, 'Size:', file.size, 'Type:', file.type);
    formData.append('files', file);
  }
  
  // Append path and type
  formData.append('path', params.path);
  formData.append('type', params.type);

  // Debug log - Check FormData content
  console.log('FormData has files:', formData.has('files'));
  console.log('FormData has path:', formData.has('path'));
  console.log('FormData has type:', formData.has('type'));
  console.log('FormData getAll files:', formData.getAll('files'));
  console.log('Upload params:', params);
  console.log('Upload formData:', formData);


  const [error, resp] = await sendHttpRequest(
    HTTP_REQUEST_TYPE.post,
    COMMON_API.POST_UPLOAD,
    formData,
    false, // needLoading - do not show global loading
    true   // isFormData - this is FormData
  );
  
  console.log('Upload response:', resp);
  console.log('Upload error:', error);
  
  if (error) {
    console.error('Upload failed with error:', error);
  }
  
  return resp;
};

/**
 * Download file from resources API
 * @param fileId - The file key/path
 * @param fileName - The name to save the file as
 * @param source - Source identifier (default: 'cx')
 * @param type - Resource type (e.g., 'carReport', 'img', etc.)
 */
const downloadFile = async (
  fileId: string,
  fileName: string,
  source: string = 'cx',
  type: string = 'carReport'
): Promise<void> => {
  try {
    // eslint-disable-next-line prefer-rest-params
    const API_BASE_URL = (globalThis as any)?.config?.REACT_APP_API_URL 
                       || process.env.REACT_APP_API_URL 
                       || '';
    const downloadUrl = `${API_BASE_URL}/eff-api/v1/resources?source=${encodeURIComponent(source)}&type=${encodeURIComponent(type)}&key=${encodeURIComponent(fileId)}`;
    
    // Fetch the file as blob
    const accessToken = await getAccessToken();
    const response = await fetch(downloadUrl, {
      method: 'GET',
      credentials: 'include',
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    });
    
    if (!response.ok) {
      throw new Error(`Download failed with status: ${response.status}`);
    }
    
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    
    // Create a temporary link and trigger download
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    // Clean up the blob URL
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Download file failed:', error);
    throw error;
  }
};

export {
  getAircraftTypeList,
  uploadFiles,
  downloadFile
};